// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-text-field .restaurar-senha[data-v-dce9bba2]{border-radius:8px}.v-text-field--outlined .v-input__control[data-v-dce9bba2]{min-height:56px}", ""]);
// Exports
module.exports = exports;
